import { IRiskCategory248 } from 'APIPackage/DictionariesModule/interfaces/IRiskCategory248';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryRiskCategorySelectOption = makeCreateDictionarySelectOption<IRiskCategory248>(
  'id',
  'title',
);
